import { Component, OnInit, Input } from '@angular/core';
import { CarouselItem, ChatMessage, CHATTYPE } from '../../models/chat-message.model';
import { EvaOption } from 'src/app/shared/interfaces/eva-options.interface';
import { ChatService } from '../../services/chat.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
//import { RemoteConfigService } from '../../services/remote-config.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  @Input() items : CarouselItem[]

  constructor(public chatService: ChatService,
    public utilsService: UtilsService)
    //private remoteConfigService: RemoteConfigService) { }
    {}
  ngOnInit() {
  }


  doAction(button: EvaOption){
    if(button.action != ''){
      window.open(button.action, "_blank");
      return;
    }


    const chatMessage: ChatMessage = new ChatMessage.Builder(CHATTYPE.SIMPLETEXT)
                                                    .withMessage( button.name)
                                                    .build();
    this.chatService.chatMessages.push(chatMessage);
    this.chatService.conversationWithEva(button.name, '', null);
    
    this.chatService.awakeAvatar();
    // this.show.emit(false);
      
  }

}
